import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../../components/RenderNavItem";
import { GrievanceRedressalLeftMenuList } from "../../utils/constants";

const Procedure = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass">{t("About_Kolkata")} </h4>
            </div>
          </div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {GrievanceRedressalLeftMenuList.map((item, index) => (
                      <RenderNavItem
                        key={item.id || index}
                        item={item}
                        index={index}
                        t={t}
                      />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">{t("Procedure")}</h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <h5 className="fontSizeClass">
                      <strong>
                        {t("New System For Submitting Complaints At KMC")}
                      </strong>
                    </h5>
                    <p className="fontSizeClass">
                      <strong>{t("Now just A Click / Form Away !")}</strong>
                    </p>
                  </div>
                  <div className="about-img3 mt-4">
                    <p>
                      KMC receives various complaints from citizens on issues
                      such as Assessment of Properties , issue of Certificate of
                      Enlistment, alteration of Building Plans , insufficient
                      Water Supply, Roads requiring repair etc .
                    </p>
                    <br></br>
                    <p>
                      KMC has launched a new system for managing these
                      complaints wherein the citizen may submit complaints
                      online or through a standard complaints form . All
                      complaints received online or through these forms will be
                      recorded in a central complaints logging e-database which
                      will help KMC in systematically monitoring the action
                      taken to resolve these complaints . These complaints form
                      have been made available at designated public grievance
                      counters at the KMC Head Quarter and all e-Kolkata citizen
                      service centers and Borough Offices . This form can also
                      be dowmloaded from this portal.
                    </p>
                  </div>

                  <div className="about-img3 mt-4">
                    <p>
                      <strong> How Will New System Work ? </strong>
                    </p>
                    <br></br>
                    <p>
                      <strong> Step One : </strong> Submit online Grievance or
                      Fill in Grievance Redressal Form with the relevant detail.
                      <br></br>
                      <strong> Step Two : </strong>Tear off the and retain the
                      lower portion of the form which will contain your
                      Complaint No . For online submittion , please note the
                      system generated Complaint No.<br></br>
                      <strong> Step Three: </strong> Submit the form at any of
                      the designated counters ( or drop it in the complaint
                      drop-box), in case the grievance is not submitted online.
                      <br></br>
                      <strong> Step Four :</strong> Check status of your
                      complaints at any of the designated counters by simply
                      quoting your Complaint No or check the status online in
                      this portal.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Procedure;
